import { useLocation } from 'react-router-dom';
import { defaultFeatureFlagValues, FeatureFlagKey } from './featureFlags';
import { useEffect } from 'react';
import { useLocalStorage } from '../LocalStorage';

//To add feature flag to URL append ?featureFlags[FeatureFlagKeyName]=true
//To remove feature flag from local storage ?featureFlags[FeatureFlagKeyName]=false
export const useFeatureFlag = (featureFlagName: FeatureFlagKey): boolean => {
  const { search } = useLocation();
  const featureFlags = new URLSearchParams(search);
  const { get, set } = useLocalStorage();
  const localStorageFeatureFlags = get<Record<string, boolean>>('featureFlags') ?? {};

  useEffect(() => {
    const newFeatureFlags: Record<string, boolean> = {};

    featureFlags.forEach((value, key) => {
      if (key.startsWith('featureFlags[') && key.endsWith(']')) {
        const flagName = key.slice('featureFlags['.length, -1);
        newFeatureFlags[flagName] = value === 'true';
      }
    });

    set('featureFlags', { ...localStorageFeatureFlags, ...newFeatureFlags });
  }, [featureFlags, set]);

  return featureFlagName in localStorageFeatureFlags
    ? localStorageFeatureFlags[featureFlagName]
    : defaultFeatureFlagValues[featureFlagName] || false;
};
